import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { isEmpty } from 'lodash';

import * as fromStore from '@core/store';
@Injectable()
export class SingleResolver implements Resolve<Observable<any>> {
  constructor() {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const result = {};
    const stringParams = route.queryParams[fromStore.CTX];
    const id = route.params['id'];
    if (!isEmpty(stringParams)) {
      result[fromStore.PARENT_CTX] = JSON.parse(stringParams);
    }
    if (!isEmpty(id)) {
      result['id'] = id;
    }
    return of(result);
  }
}
